import { useState } from "react";
import classNames from "classnames";
import { DownArrowIcon } from "@shared/ui/Icon/ui/Accordion/DownArrowIcon";
import { AccordionProps } from "./types";
import classes from "./Accordion.module.scss";

export const Accordion = ({ title, inner, action }: AccordionProps) => {
    const [selected, setSelected] = useState(false);

    const toggleAccordion = () => {
        setSelected(!selected);
    };

    return (
        <div className={classes.accordion}>
            <div className={classes.accordion__top} onClick={toggleAccordion}>
                <span className={classes["accordion__title"]}>{title}</span>
                <div className={classes.accordion__actions}>
                    {action && action}
                    <DownArrowIcon
                        className={classNames(
                            classes["accordion__icon"],
                            selected && classes["accordion__icon--rotated"]
                        )}
                    />
                </div>
            </div>
            <div
                className={classNames(
                    classes.accordion__inner,
                    selected && classes["accordion__inner--collapsed"]
                )}
            >
                {inner}
            </div>
        </div>
    );
};